import { DownPolygonIcon } from '../../icons';

export const Indicator = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-col items-center pb-[2px]">
      <div className="whitespace-nowrap text-microMedium text-brandMidnight">
        {title}
      </div>
      <DownPolygonIcon />
    </div>
  );
};
